/**
 * Moduł do zarządzania statusem mobilnym
 *
 * @export
 * @class MobileModule
 */
export class MobileModule {
  /**
   * Domyślny stan modułu
   *
   * @private
   * @memberof MobileModule
   */
  private defaultState = {
    mobileNav: false
  };

  /**
   * Stan modułu
   *
   * @memberof MobileModule
   */
  public state = {
    ...this.defaultState
  };

  public mutations = {
    setMobileNav(localState: any, value: boolean) {
      localState.mobileNav = value;
    }
  };

  public actions = {
    setMobileNav(context: any, value?: boolean) {
      if (typeof value === 'boolean') {
        context.commit('setMobileNav', value);
      } else {
        context.commit('setMobileNav', !context.state.mobileNav);
      }
    }
  };

  public getters = {};
}

export default new MobileModule();
